export interface ModuleApiModel {
  id: string;
  name: string;
  key: string;
  available_offline: boolean;
}
